export const scrumConstant = {
    LOAD_SCRUM_REQUEST: 'LOAD_SCRUM_REQUEST',
    LOAD_SCRUM_SUCCESS: 'LOAD_SCRUM_SUCCESS',
    LOAD_SCRUM_FAILURE: 'LOAD_SCRUM_FAILURE',

    LOAD_SCRUM_BY_ID_REQUEST: 'LOAD_SCRUM_BY_ID_REQUEST',
    LOAD_SCRUM_BY_ID_SUCCESS: 'LOAD_SCRUM_BY_ID_SUCCESS',
    LOAD_SCRUM_BY_ID_FAILURE: 'LOAD_SCRUM_BY_ID_FAILURE'
};